@if (forceTo == 'full-sized') {
  <div class="preloader-full-size">
    <div class="spinner-static">
      <img src='../../../../assets/images/logo.png'>
    </div>
    <div class="loader">
      <span></span>
    </div>
  </div>
}
@if (forceTo == 'component-sized') {
  <div class="preloader-component">
    <div class="spinner-static">
      <img src='../../../../assets/images/logo.png'>
    </div>
    <div class="loader">
      <span></span>
    </div>
  </div>
}